export const AppConfig = {
  quickSwapGQLEndpoint:
    "https://api.thegraph.com/subgraphs/name/sameepsi/quickswap06",
  balancerGQLEndpoint:
    "https://api.thegraph.com/subgraphs/name/balancer-labs/balancer-polygon-v2",
  dystopiaGQLEndpoint:
    "https://api.thegraph.com/subgraphs/name/dystopia-exchange/dystopia",
};
